var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTableArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.5rem",
    height: "0.625rem",
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333313 0.333496L0.333313 9.66683L7.66665 5.00016L0.333313 0.333496Z",
    fill: "#90A4AE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableArrow);
export default __webpack_public_path__ + "static/media/tableArrow.343ef45e9f958dfdc84edb9b19e1e915.svg";
export { ForwardRef as ReactComponent };